import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import ExpandButton from 'components/common/button/expand'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import Typo from 'constants/typography'
import { segmentVirtualTryOnProductListClicked } from 'components/pdp/product-virtual-try-on/pdp-virtual-try-on-segment/pdpVirtualTryOnSegment'
import Button from 'components/common/button'
import HoverInteractionsAddToBag from './add-to-bag'

const ProductItemHoverInteractions = ({
  goToSimilarProducts,
  options,
  productId,
  refId,
  refType,
  showAddToBag,
  showSeeSimilar,
  t,
  productUrl,
  virtual_try_on_enabled,
  category_link_rewrite,
  id_category_default,
}) => {
  const wrapperRef = useRef()

  // To resolve issue with animation triggers on page load
  useEffect(() => {
    if (wrapperRef?.current) {
      wrapperRef.current.classList?.add('not-ready')

      const requestId = requestAnimationFrame(() =>
        wrapperRef?.current?.classList?.remove('not-ready'),
      )

      return () => cancelAnimationFrame(requestId)
    }
    return undefined
  }, [wrapperRef])

  return (
    <div className="product-hover-interactions" ref={wrapperRef}>
      {showSeeSimilar && (
        <div className="product-hover-interactions__see-similar">
          <ExpandButton className="similar-cta" onClick={goToSimilarProducts}>
            <Icon size={20} src={ICONS.similarProduct} />
            {hasLocizeTranslation(t, 'CATEGORY_SIMILAR_CTA', 'see similar')}
          </ExpandButton>
        </div>
      )}
      {virtual_try_on_enabled && (
        <div className="product-hover-interactions__virtual-try-on">
          <Button
            className="product-hover-interactions__virtual-try-on__link"
            onClick={(e) => {
              segmentVirtualTryOnProductListClicked({
                id_product: productId,
                site_category_name: category_link_rewrite,
                id_site_category: id_category_default,
                list_type: 'web_desktop',
              })
              e.preventDefault()
              e.stopPropagation()
              window.open(
                `${productUrl}?virtual-try-on=true`,
                '_blank',
                'noopener,noreferrer',
              )
            }}
          >
            <Icon
              size={ICON_SIZE.medium}
              src={ICONS.virtualHanger}
              alt="virtual hanger icon"
            />
            <span className={Typo.subtitle2}>
              {hasLocizeTranslation(t, 'TRY_IT_ON', 'Try It On')}
            </span>
          </Button>
        </div>
      )}
      {showAddToBag && options?.length > 0 && (
        <HoverInteractionsAddToBag
          options={options}
          productId={productId}
          refData={{ ref_type: refType, ref_id: refId }}
        />
      )}
    </div>
  )
}

ProductItemHoverInteractions.defaultProps = {
  options: null,
  refId: '',
  refType: null,
  productUrl: '',
  showAddToBag: false,
  showSeeSimilar: false,
  virtual_try_on_enabled: false,
  category_link_rewrite: null,
  id_category_default: null,
}

ProductItemHoverInteractions.propTypes = {
  goToSimilarProducts: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  productId: PropTypes.number.isRequired,
  refId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  refType: PropTypes.string,
  showAddToBag: PropTypes.bool,
  showSeeSimilar: PropTypes.bool,
  t: PropTypes.func.isRequired,
  productUrl: PropTypes.string,
  virtual_try_on_enabled: PropTypes.bool,
  category_link_rewrite: PropTypes.string,
  id_category_default: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
}

const Extended = translate('global')(ProductItemHoverInteractions)

export { ProductItemHoverInteractions }

export default Extended
